import dictionaries from '@/common/vue-i18n-locales.generated';

export default dictionaries;
